import { render, staticRenderFns } from "./DisplayRawFile.vue?vue&type=template&id=2c9c5e80&scoped=true"
import script from "./DisplayRawFile.vue?vue&type=script&lang=js"
export * from "./DisplayRawFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c5e80",
  null
  
)

export default component.exports